module.exports = __webpack_public_path__ + "static/media/icon-change-policy.35f8e517.svg";